import AbstractScene from './AbstractScene.js';
import Popup from '../prefabs/Popup.js';
import ButtonArrow from '../prefabs/buttons/ButtonArrow.js';
import EndScreen from '../prefabs/EndScreen.js';
import Menu from '../prefabs/Menu.js';

export default class Activite3 extends AbstractScene {
    constructor() {
        super({
            key: "Activite3"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }

    create() {
        this.background = this.add.image(0, 0, 'act3Background').setOrigin(0, 0);

        let ctnt = "Sur notre trajet, prenons quelques minutes pour nous intéresser à la chaîne alimentaire dans la mer Méditerranée..."
        this.popup = new Popup(this, ctnt, 'act3MissionCartouche', () => { this.firstBtn.setAlpha(1) })
        this.popup.launchAnim()

        this.firstBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "C'est parti !", "24px", true).setAlpha(0)
        this.secondBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "Suivant", "24px", false).setAlpha(0);
        this.questionMark = this.add.image(100, this.height - 60, 'questionIcon').setOrigin(0.5).setAlpha(0)
        this.questionMark.setInteractive({ useHandCursor: true })

        this.firstBtn.setClickFunction(() => {
            this.tweens.add({
                targets: [this.popup],
                duration: 500,
                ease: 'Cubic.easeInOut',
                scale: 0,
                x: 40,
                y: this.height - 60,

                onComplete: () => {
                    this.firstBtn.setAlpha(0);
                    this.secondBtn.setAlpha(1);
                    this.popup.setAlpha(0);
                    this.questionMark.setAlpha(1)
                }
            })
        })
        this.questionMark.on('pointerdown', () => {
            this.popup.setAlpha(1);
            this.questionMark.setAlpha(0);
            this.tweens.add({
                targets: [this.popup],
                duration: 500,
                ease: 'Cubic.easeInOut',
                scale: 1,
                x: this.width / 2,
                y: this.height / 2,
                onComplete: () => {
                    this.firstBtn.setAlpha(1);
                    this.secondBtn.setAlpha(0);
                }
            })
        })
        this.secondBtn.setClickFunction(() => {
            this.secondBtn.setAlpha(0);
            this.questionMark.disableInteractive();
            this.endScreen.setAlpha(1);
            this.endScreen.launchAnim()
        })


        let ctnt2 = "C’est la menace principale pour l’équilibre de la chaîne alimentaire…"
        this.endScreen = new EndScreen(this, ctnt2, 'act3BouteilleMessage', 'Activite3Video')
        this.endScreen.setAlpha(0);

        new Menu(this)
    }
}